var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('span',{staticClass:"badge badge-pill badge-item badge-star",class:{'item-selected-badge': _vm.selected === true},on:{"click":function($event){$event.stopPropagation();return _vm.click($event)}}},[_vm._v("★")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }